module.exports = __webpack_public_path__ + "img/1566739963.e804713d.jpg";